import React, { useState } from 'react'
import Button from '../buttons/Button'
import router from 'next/router';

interface CallToActionBoxProps {
  body: string,
  btnText: string,
  href?: string,
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
const CallToActionBox: React.FC<CallToActionBoxProps> = ({ body, btnText, href, onClick }) => {
  const handleClick = (e) => {
    if(href) router.push(href);
    if(onClick) onClick(e)
  }
  return (
    <div className="bg-highlight-yellow rounded-lg text-center flex">
      <div className="p-4 space-y-4 max-w-lg flex flex-col items-center lg:p-8 lg:mx-auto">
        <div className="text-white text-lg lg:text-xl font-bold">{body}</div>
        <div className="hidden lg:block "><Button onClick={handleClick} size="sm" type="secondary">{btnText}</Button></div>
        <div className="block lg:hidden"><Button onClick={handleClick} size="sm" type="secondary" block>{btnText}</Button></div>
      </div>
    </div>
  )
}


export default CallToActionBox;